export enum LoadStatus { 
  Loading = 0, 
  Ready, 
  Error,
}